(function(W,D){
'use strict';
/*
 * ThermoAspen Project Handoff 1.5.6
 * 1.5.6 (28 Oct 2026, speed): the first copy of the design into the working project is made
 * when the browser is idle (within 2 s) instead of while the Designer is starting. The
 * workflow links, the Summary and every design change still copy it straight away.
 * Session-scoped cross-template working-project bridge.
 *
 * Purpose:
 * - carry one canonical ThermoAspenProject record between Shopify templates;
 * - keep project data out of the URL;
 * - use sessionStorage only (no permanent localStorage project copy);
 * - let the Materials page update canonical interior finish state without mounting Designer;
 * - retain procurement and optimiser choices in the same working-project record;
 * - apply the working project back through Project Store when Designer is mounted again;
 * - provide ordered Designer -> Construction Drawings -> Cutting Lists -> Interior Materials workflow navigation;
 * - auto-apply a returned Materials project once, only after explicit navigation back to Designer.
 *
 * This block owns no geometry or procurement calculations.
 */
var VERSION='1.5.6',SCHEMA_NAME='ThermoAspenProject',SCHEMA_VERSION=1,KEY='ThermoAspenWorkingProjectV1',NAV_KEY='ThermoAspenWorkingProjectNavV1',BRIDGE_KEY='ThermoAspenWorkingProjectBridgeV1',MATERIALS_URL='/pages/materials-and-cladding',DESIGNER_URL='/pages/sauna-designer',CONSTRUCTION_URL='/pages/construction-test-page',MANUFACTURING_URL='/pages/cutting-manufacturing',off=[],autoApplying=false;

function ownNav(){
  var all=D.querySelectorAll('[id="ti-workflow-nav"]'),mine=null;
  Array.prototype.forEach.call(all,function(n){
    if(n.getAttribute('data-ti-handoff-version')===VERSION)mine=n
  });
  if(!mine&&all.length)mine=all[all.length-1];
  Array.prototype.forEach.call(all,function(n){
    if(n!==mine&&n.parentNode)n.parentNode.removeChild(n)
  });
  return mine
}

function removeLegacyConstructionGuards(){
  var g=W.__ThermoAspenConstructionNavGuard,legacy=W.__ThermoAspenConstructionNavGuardV135;
  if(g&&g.fn)try{D.removeEventListener('click',g.fn,true)}catch(e){}
  if(legacy)try{D.removeEventListener('click',legacy,true)}catch(e){}
  try{delete W.__ThermoAspenConstructionNavGuard}catch(e){W.__ThermoAspenConstructionNavGuard=null}
  try{delete W.__ThermoAspenConstructionNavGuardV135}catch(e){W.__ThermoAspenConstructionNavGuardV135=null}
}
function clone(v){if(v==null)return v;try{return JSON.parse(JSON.stringify(v))}catch(e){return v}}
function obj(v){return!!v&&typeof v==='object'&&!Array.isArray(v)}
function n(v,f){v=Number(v);return isFinite(v)?v:(f==null?0:f)}
function int(v,f){return Math.round(n(v,f))}
function isLegacy300Window(x){return!!(x&&x.type==='window'&&Math.round(n(x.frameWidthMm))===300&&Math.round(n(x.frameHeightMm))===300)}
function starterWindowForDesign(d,door){d=d||{};var r=d.room||{},L=Math.max(0,n(r.lengthMm)),W=Math.max(0,n(r.widthMm)),H=Math.max(0,n(r.heightMm)),dw=door&&door.wall||'left',choices=(dw==='left'||dw==='right')?['back','front']:['left','right'],span=function(w){return w==='front'||w==='back'?L:W},wall=choices.find(function(w){return span(w)>=600})||choices[0],usable=Math.max(0,span(wall)-600);return{id:'window.01',type:'window',enabled:true,wall:wall,offsetMm:Math.max(0,Math.min(usable,Math.round(usable/2/50)*50)),frameWidthMm:600,frameHeightMm:600,sillHeightMm:Math.max(0,Math.min(1200,H-600))}}
function sanitiseDesignWindows(d){d=clone(d);if(!d||!d.openings)return d;var o=d.openings;if(Array.isArray(o)){var had=false,hadWindow=false,out=[];o.forEach(function(x){if(x&&x.type==='window')hadWindow=true;if(isLegacy300Window(x)){had=true;return}out.push(x)});if(had&&hadWindow&&!out.some(function(x){return x&&x.type==='window'})){var door=out.find(function(x){return x&&x.type==='door'})||null;out.push(starterWindowForDesign(d,door))}d.openings=out}else if(obj(o)){var win=o.window||o['window.01'];if(isLegacy300Window(win)){var door=o.door||o['door.01']||null,rep=starterWindowForDesign(d,door);if(o.window)o.window=rep;else o['window.01']=rep}}return d}
function sanitiseRecordWindows(p){p=clone(p);if(p&&p.design)p.design=sanitiseDesignWindows(p.design);return p}
function same(a,b){try{return JSON.stringify(a)===JSON.stringify(b)}catch(e){return false}}
function now(){return new Date().toISOString()}
function on(a,t,f){if(!a||!a.addEventListener)return;a.addEventListener(t,f);off.push(function(){a.removeEventListener(t,f)})}
function dispatch(name,detail){try{W.dispatchEvent(new CustomEvent(name,{detail:detail}))}catch(e){try{var ev=D.createEvent('CustomEvent');ev.initCustomEvent(name,false,false,detail);W.dispatchEvent(ev)}catch(x){}}}
function store(){return W.__ThermoAspenProjectStore||null}
function runtime(){return W.ThermoAspenProjectRuntime||null}
function materials(){return W.__ThermoAspenMaterialsV2||null}
function optimiser(){return W.__ThermoAspenCladdingOptimiser||null}
function designer(){return W.__ThermoAspenDesignerV5||null}
function constructionSpec(){return W.ThermoAspenConstructionSpecV1||null}
function withConstructionSpec(p){if(!p||!p.room)return p;p=clone(p);if(!p.constructionSpec){var c=constructionSpec(),r=c&&typeof c.getCurrentRequest==='function'?c.getCurrentRequest():null;if(r)p.constructionSpec=clone(r)}return p}
function syncConstructionSpec(p){var c=constructionSpec(),d=p&&p.design;if(c&&d&&d.constructionSpec&&typeof c.loadProject==='function')try{c.loadProject(d,{silent:true,reason:'handoff-read'})}catch(e){}return p}
function storage(){try{return W.sessionStorage||null}catch(e){return null}}
function bridgeStorage(){try{return W.localStorage||null}catch(e){return null}}
function writeBridge(p){
  p=sanitiseRecordWindows(p);var b=bridgeStorage();
  if(!b||!validRecord(p))return false;
  try{
    b.setItem(BRIDGE_KEY,JSON.stringify({expiresAt:Date.now()+300000,project:clone(p)}));
    return true
  }catch(e){return false}
}
function readBridge(){
  var b=bridgeStorage(),x;
  if(!b)return null;
  try{x=JSON.parse(b.getItem(BRIDGE_KEY)||'null')}catch(e){x=null}
  if(!x||!validRecord(x.project))return null;
  if(Number(x.expiresAt)>0&&Date.now()>Number(x.expiresAt)){
    try{b.removeItem(BRIDGE_KEY)}catch(e){}
    return null
  }
  return sanitiseRecordWindows(x.project)
}
function clearBridge(){
  var b=bridgeStorage();
  if(!b)return;
  try{b.removeItem(BRIDGE_KEY)}catch(e){}
}

function validRecord(p){return!!(obj(p)&&obj(p.schema)&&p.schema.name===SCHEMA_NAME&&Number(p.schema.version)===SCHEMA_VERSION&&obj(p.design)&&obj(p.design.room))}
function readRecord(){
  var ss=storage(),p,b;
  if(ss){
    try{p=JSON.parse(ss.getItem(KEY)||'null')}catch(e){p=null}
    if(validRecord(p)){p=sanitiseRecordWindows(p);try{ss.setItem(KEY,JSON.stringify(p))}catch(e){}syncConstructionSpec(p);return clone(p)}
  }
  b=readBridge();
  if(!b)return null;
  if(ss){
    try{
      ss.setItem(KEY,JSON.stringify(b));
      clearBridge();
    }catch(e){}
  }
  syncConstructionSpec(b);return clone(b)
}
function writeRecord(p,source){var s=storage();p=sanitiseRecordWindows(p);if(!s||!validRecord(p))return false;p=clone(p);if(!p.revision)p.revision={number:1,status:'working',createdAt:now(),updatedAt:now()};p.revision.number=Math.max(1,int(p.revision.number,1));p.revision.status='working';p.revision.updatedAt=now();try{s.setItem(KEY,JSON.stringify(p))}catch(e){return false}dispatch('ThermoAspenProjectHandoffUpdated',{source:source||'handoff',version:VERSION,project:clone(p),design:clone(p.design),revision:p.revision.number});return true}
function currentDesign(){
  var d=designer(),dd=W.ThermoAspenSaunaDesignerData,r=runtime(),p;
  if(d&&typeof d.getProjectState==='function'){
    try{p=d.getProjectState();if(p&&p.room)return withConstructionSpec(sanitiseDesignWindows(p))}catch(e){}
  }
  p=dd&&dd.project;
  if(p&&p.room)return withConstructionSpec(sanitiseDesignWindows(p));
  if(r&&typeof r.readCurrentProject==='function'){
    try{p=r.readCurrentProject();if(p&&p.room)return withConstructionSpec(sanitiseDesignWindows(p))}catch(e){}
  }
  p=readRecord();
  return p?withConstructionSpec(p.design):null
}
function preferences(){var m=materials();if(m&&typeof m.getPreferences==='function')try{return clone(m.getPreferences())}catch(e){}return null}
function optimiserState(){var o=optimiser();if(o&&typeof o.getState==='function')try{return clone(o.getState())}catch(e){}return null}
function applyProcurement(p,pref){if(!p||!pref)return p;var mix=pref.timberGradeMix||{},b=Math.max(0,Math.min(100,int(mix.g2SharePct,100)));p.procurement={orderMode:pref.claddingGradeMode==='recommended'?'optimised':'customised',customGradeMix:{selectBPercent:b,aGradePercent:100-b},claddingWastagePercent:Math.max(0,Math.min(15,int(pref.claddingWastePct,10))),benchSupply:pref.benchSupply==='prefabricated'?'prefabricated':'site-built',sourcePreferences:clone(pref)};return p}
function applyOptimiser(p,state){if(!p||!state)return p;p.optimiser={zoneGradeOverrides:clone(state.zoneGradeOverrides||{}),stockLengthOverrides:clone(state.stockLengthOverrides||{})};return p}
function minimalRecord(design){var t=now();return{schema:{name:SCHEMA_NAME,version:SCHEMA_VERSION,units:'mm'},identity:{projectId:null,projectName:'Untitled Sauna Project',ownerRef:null},revision:{number:1,status:'working',createdAt:t,updatedAt:t},design:clone(design),procurement:{orderMode:'customised',customGradeMix:{selectBPercent:100,aGradePercent:0},claddingWastagePercent:10,benchSupply:'site-built',sourcePreferences:{}},optimiser:{zoneGradeOverrides:{},stockLengthOverrides:{}},generated:null,drawings:{currentSet:null,issuedSets:[]},audit:{createdBy:null,lastModifiedBy:null}}}
// Window issue data is a CHECKED snapshot from the existing Designer editor,
// NOT a separate construction-page validator or an independent authority.
function designSignature(d){
  var s;try{s=JSON.stringify(d||null)}catch(e){return null}
  var h=2166136261;for(var i=0;i<s.length;i++){h^=s.charCodeAt(i);h=Math.imul(h,16777619)}
  return String(s.length)+':'+(h>>>0).toString(16)
}
function checkedWindowStatus(record,live){
  if(!record||!record.design)return null;
  var audit=record.audit&&record.audit.windowIssues;
  if(!audit)return {state:'unverified',count:0,issues:[]};
  if(audit.designSignature!==designSignature(record.design))return {state:'unverified',count:0,issues:[]};
  if(!/^(valid|invalid|incomplete)$/.test(audit.state))return {state:'unverified',count:0,issues:[]};
  return {state:audit.state,count:audit.count,issues:clone(audit.issues||[]),checkedAt:audit.checkedAt};
}
function keepWindowAudit(record,previous){
  if(!record||!previous||!previous.audit||!previous.audit.windowIssues)return;
  record.audit=record.audit||{};
  if(!record.audit.windowIssues)record.audit.windowIssues=clone(previous.audit.windowIssues)
}
function saveLiveWindowAudit(record,force){
  if(!record||pageRole()!=='designer')return false;
  var e=W.ThermoAspenWallOpeningEditorV1;
  if(!e||typeof e.getProjectWindowIssues!=='function')return false;
  var result=null;
  try{result=(force&&typeof e.validateProjectWindowsNow==='function')?e.validateProjectWindowsNow():e.getProjectWindowIssues()}catch(ex){return false}
  if(!result||!/^(valid|invalid|incomplete)$/.test(String(result.state||'')))return false;
  var candidates=Array.isArray(result.issues)?result.issues:[],allowed=Object.create(null);
  (Array.isArray(record.design.openings)?record.design.openings:[]).forEach(function(o){
    if(o&&o.type==='window'&&o.enabled!==false)allowed[String(o.id)+'|'+String(o.wall)]=true;
  });
  var issues=candidates.filter(function(o){return o&&allowed[String(o.id)+'|'+String(o.wall)];}).map(function(o){
    return {id:String(o.id),wall:String(o.wall),code:String(o.code||o.id),message:String(o.message||'Window requires adjustment')};
  });
  // Incomplete results must not be silently labelled structurally valid.
  var state=String(result.state);
  if(state==='invalid'&&issues.length===0)state='incomplete';
  record.audit=record.audit||{};
  record.audit.windowIssues={state:state,count:issues.length,issues:issues,
    designSignature:designSignature(record.design),checkedAt:now(),authority:'WallOpeningEditor'};
  return true
}
function getWindowIssueStatus(){return checkedWindowStatus(readRecord())}
function captureCurrent(){
  var st=store(),p=null,d=currentDesign(),existing=readRecord(),rev;
  if(d&&d.room){
    p=existing||minimalRecord(d);
    p.design=clone(d);
    applyProcurement(p,preferences());
    applyOptimiser(p,optimiserState());
    p.generated=null;
  }
  if(designer()&&st&&typeof st.exportProject==='function'){
    try{
      rev=typeof st.getRevision==='function'?Math.max(1,int(st.getRevision(),1)):1;
      var full=st.exportProject({revisionNumber:rev});
      if(validRecord(full)){
        if(p){
          full.design=clone(p.design);
          full.procurement=clone(p.procurement);
          full.optimiser=clone(p.optimiser);
          full.generated=null;
        }
        p=full;
      }
    }catch(e){}
  }
  if(!p||!validRecord(p))return null;
  keepWindowAudit(p,existing);
  saveLiveWindowAudit(p,true);
  return writeRecord(p,'capture')?readRecord():null
}
function getDesign(){var p=readRecord();return p?sanitiseDesignWindows(p.design):null}
function getRevision(){var p=readRecord();return p&&p.revision?Math.max(1,int(p.revision.number,1)):null}
function profileSpec(label){label=String(label||'');if(label==='STS4 15x140')return{profile:'STS4 15x140',nominalWidthMm:140,coverageMm:130};return{profile:'STS4 15x120',nominalWidthMm:120,coverageMm:110}}
function patchInteriorFinish(v){v=v||{};var p=readRecord(),i,w,c,label,spec;if(!p)return false;i=p.design.interior||(p.design.interior={materialCode:'TASP'});w=i.wallCladding||(i.wallCladding={});c=i.ceilingCladding||(i.ceilingCladding={});label=v.wallProfile||v.profile||v.ceilingProfile;if(label){spec=profileSpec(label);w.profile=spec.profile;w.nominalWidthMm=spec.nominalWidthMm;w.coverageMm=spec.coverageMm;c.profile=spec.profile;c.nominalWidthMm=spec.nominalWidthMm;c.coverageMm=spec.coverageMm}if(v.wallDirection!=null)w.direction=String(v.wallDirection).toLowerCase()==='horizontal'?'horizontal':'vertical';if(v.ceilingDirection!=null)c.direction=String(v.ceilingDirection).toLowerCase()==='parallel'?'parallel':'perpendicular';if(v.tileUpstandMm!=null&&isFinite(Number(v.tileUpstandMm)))w.tileUpstandMm=Math.max(0,Math.min(500,int(v.tileUpstandMm)));p.generated=null;return writeRecord(p,'interior-finish')}
function patchConstructionSpec(v){var p=readRecord(),c=constructionSpec(),q=clone(v||{}),test;if(!p||!p.design||!q||typeof q!=='object')return false;if(c&&typeof c.resolve==='function'){try{test=c.resolve({constructionSpec:q});if(!test||test.valid===false)return false}catch(e){return false}}p.design.constructionSpec=q;p.generated=null;if(c&&typeof c.loadProject==='function')try{c.loadProject(p.design,{silent:true,reason:'handoff-construction-spec'})}catch(e){}return writeRecord(p,'construction-spec')}
function syncProcurement(pref){var p=readRecord(),before;if(!p)return false;before=clone(p.procurement||null);applyProcurement(p,pref||preferences());if(same(before,p.procurement))return true;p.generated=null;return writeRecord(p,'procurement')}
function syncOptimiser(state){var p=readRecord(),before;if(!p)return false;before=clone(p.optimiser||null);applyOptimiser(p,state||optimiserState());if(same(before,p.optimiser))return true;p.generated=null;return writeRecord(p,'optimiser')}
function applyToDesigner(options){
  var p=readRecord(),s=store(),toImport,targetSchema;
  if(!p)return Promise.reject(new Error('No working ThermoAspen project is available in this browser session.'));
  if(!designer())return Promise.reject(new Error('Sauna Designer is not mounted on this page.'));
  if(!s||typeof s.importProject!=='function')return Promise.reject(new Error('Project Store import API is not available.'));
  // The cross-template handoff record uses envelope schema 1, while the
  // current Project Store 1.7.3 imports envelope schema 2. The underlying
  // design is already schema 2. Adapt a COPY only for the import boundary;
  // retain the original handoff record (and every exact opening offset).
  targetSchema=Number(s.projectSchemaVersion);
  if(!p.schema||p.schema.name!==SCHEMA_NAME||Number(p.schema.version)!==SCHEMA_VERSION||
     !p.design||Number(p.design.schemaVersion)!==targetSchema||targetSchema!==2){
    return Promise.reject(new Error('Project Handoff / Store schema mismatch: refusing to reset or substitute a default design.'));
  }
  toImport=clone(p);
  toImport.schema.version=targetSchema;
  return s.importProject(toImport,options||{}).then(function(result){
    captureCurrent();
    dispatch('ThermoAspenProjectHandoffApplied',{version:VERSION,project:readRecord(),result:clone(result)});
    return result;
  });
}
function clear(){var s=storage();if(!s)return false;try{s.removeItem(KEY);s.removeItem(NAV_KEY)}catch(e){return false}clearBridge();dispatch('ThermoAspenProjectHandoffCleared',{version:VERSION});return true}
function hasWorkingProject(){return!!readRecord()}
function readNav(){var s=storage(),v;if(!s)return null;try{v=JSON.parse(s.getItem(NAV_KEY)||'null')}catch(e){return null}return obj(v)&&/^(materials|designer|construction|manufacturing)$/.test(String(v.target||''))?v:null}
function writeNav(target,options){var s=storage(),p=readRecord(),v;if(!s||!p||!/^(materials|designer|construction|manufacturing)$/.test(String(target||'')))return false;v={target:String(target),revision:getRevision(),createdAt:now()};if(target==='designer'&&options&&options.windowIssue&&options.windowIssue.id&&options.windowIssue.wall)v.windowIssue={id:String(options.windowIssue.id),wall:String(options.windowIssue.wall)};try{s.setItem(NAV_KEY,JSON.stringify(v));return true}catch(e){return false}}
function clearNav(){var s=storage();if(!s)return false;try{s.removeItem(NAV_KEY);return true}catch(e){return false}}
function cleanPath(v){v=String(v||'').toLowerCase().replace(/\/+$/,'');return v||'/'}
function pageRole(){
  var path=cleanPath(W.location&&W.location.pathname);
  if(path===cleanPath(DESIGNER_URL)||D.getElementById('ti-design-projects')||designer())return'designer';
  if(path===cleanPath(MATERIALS_URL)||D.getElementById('ti-materials-list'))return'materials';
  if(path===cleanPath(CONSTRUCTION_URL)||D.getElementById('ti-construction-drawings'))return'construction';
  if(path===cleanPath(MANUFACTURING_URL)||D.querySelector('[data-ta-manufacturing-root]'))return'manufacturing';
  return'unknown'
}
function destinationUrl(target,override){if(override)return String(override);if(target==='designer')return DESIGNER_URL;if(target==='construction')return CONSTRUCTION_URL;if(target==='manufacturing')return MANUFACTURING_URL;return MATERIALS_URL}
function navigate(target,url,options){
  var p=captureCurrent()||readRecord(),dest=destinationUrl(target,url);
  if(p){
    writeNav(target,options);
    writeBridge(p);
  }
  W.location.href=dest;
  return true
}
function goToMaterials(url){return navigate('materials',url)}
function goToDesigner(url){return navigate('designer',url)}
function goToConstruction(url){return navigate('construction',url)}
function goToManufacturing(url){return navigate('manufacturing',url)}
function goToWindowIssue(id,wall){
  var rec=readRecord(),s=checkedWindowStatus(rec);
  if(!s||(s.state!=='invalid'&&s.state!=='incomplete')||!s.issues.some(function(x){return x.id===String(id)&&x.wall===String(wall)}))return false;
  return navigate('designer',null,{windowIssue:{id:id,wall:wall}})
}
function setButtonBusy(btn,text){if(!btn)return;btn.disabled=true;btn.setAttribute('aria-busy','true');btn.setAttribute('data-ti-old-label',btn.innerHTML);if(text)btn.innerHTML='<span class="ti-workflow-number">…</span><span class="ti-workflow-copy"><strong>'+text+'</strong><small>Please wait</small></span>'}
function restoreButton(btn){if(!btn)return;btn.disabled=false;btn.removeAttribute('aria-busy');var x=btn.getAttribute('data-ti-old-label');if(x){btn.innerHTML=x;btn.removeAttribute('data-ti-old-label')}}
function workflowButton(stage){var nav=ownNav();return nav?nav.querySelector('[data-ti-stage="'+stage+'"]'):null}
function removeLegacyNavigationUI(){var b=D.getElementById('ti-project-materials'),bar=D.getElementById('ti-handoff-materials-nav');if(b&&b.parentNode)b.parentNode.removeChild(b);if(bar&&bar.parentNode)bar.parentNode.removeChild(bar)}
function windowIssueNotice(){
  var el=D.getElementById('ti-window-issues-notice');
  var role=pageRole();
  if(role!=='construction'&&role!=='manufacturing'){if(el&&el.parentNode)el.parentNode.removeChild(el);return}
  var nav=ownNav();if(!nav||!nav.parentNode)return;
  var rec=readRecord(),s=checkedWindowStatus(rec);
  if(!rec){if(el)el.hidden=true;return}
  if(s&&s.state==='valid'){if(el)el.hidden=true;return}
  if(!el){
    el=D.createElement('section');el.id='ti-window-issues-notice';
    el.setAttribute('role','region');el.setAttribute('aria-label','Window adjustment status');
    el.className='ti-window-issues-notice';
    nav.parentNode.insertBefore(el,nav.nextSibling);
  }
  el.hidden=false;
  while(el.firstChild)el.removeChild(el.firstChild);
  function elt(tag,cls,text){var x=D.createElement(tag);if(cls)x.className=cls;if(text!=null)x.textContent=text;return x}
  function link(text,cb){var b=elt('button','ti-window-issues-go',text);b.type='button';b.addEventListener('click',cb);return b}
  var hasIssues=s&&(s.state==='invalid'||s.state==='incomplete')&&s.issues.length;
  el.classList.toggle('ti-window-issues-notice--unverified',!hasIssues);
  el.appendChild(elt('h2',null,hasIssues?'⚠ Adjust Windows ('+s.issues.length+')':'Window validation required'));
  el.appendChild(elt('p',null,hasIssues?'The windows below need adjustment. Drawings and cutting lists must not be treated as structurally cleared until these issues are resolved.':'Windows have not been fully checked against this version of the design. Return to the Designer to run the authoritative window checks.'));
  if(hasIssues){
    var ul=elt('ul');s.issues.forEach(function(issue){
      var li=elt('li'),info=elt('span',null,String(issue.code)+' — '+String(issue.wall)+' wall: '+String(issue.message));
      li.appendChild(info);
      li.appendChild(link('Adjust '+String(issue.code),function(){goToWindowIssue(issue.id,issue.wall)}));
      ul.appendChild(li)
    });el.appendChild(ul)
  }
  if(!hasIssues)el.appendChild(link('Open Designer',function(){goToDesigner()}))
}
function ensureWindowIssueStyle(){
  if(D.getElementById('ti-window-issues-style'))return;
  var s=D.createElement('style');s.id='ti-window-issues-style';s.textContent=[
  '#ti-window-issues-notice{width:min(100%,1240px);box-sizing:border-box;margin:0 auto 18px;padding:15px 18px;background:#fff8f4;border:1px solid #dc9b86;border-left:5px solid #ad3c2d;border-radius:8px;color:#372e2c;font:14px/1.45 system-ui,sans-serif}',
  '#ti-window-issues-notice[hidden]{display:none!important}',
  '#ti-window-issues-notice h2{font:700 17px/1.3 system-ui,sans-serif;margin:0 0 5px;color:#812c20}',
  '#ti-window-issues-notice p{margin:0 0 10px}',
  '#ti-window-issues-notice ul{list-style:none;margin:0;padding:0}',
  '#ti-window-issues-notice li{display:flex;flex-wrap:wrap;align-items:center;justify-content:space-between;gap:9px;padding:9px 0;border-top:1px solid #ebd8d2}',
  '#ti-window-issues-notice .ti-window-issues-go{font:600 13px system-ui,sans-serif;padding:7px 11px;border-radius:6px;border:1px solid #ae4d3e;background:#fff;color:#842c22;cursor:pointer}',
  '#ti-window-issues-notice .ti-window-issues-go:hover{background:#fceae5}',
  '#ti-window-issues-notice--unused{}',
  '#ti-window-issues-notice.ti-window-issues-notice--unverified{background:#f7f7f3;border-color:#b4b8af;border-left-color:#777d73}',
  '#ti-window-issues-notice.ti-window-issues-notice--unverified h2{color:#465046}'
  ].join('\n');(D.head||D.documentElement).appendChild(s)
}
function renderWorkflowNav(){
  var role=pageRole(),nav=ownNav(),stages=['designer','construction','manufacturing','materials'];
  if(!nav)return false;
  removeLegacyNavigationUI();
  ensureWindowIssueStyle();

  stages.forEach(function(stage){
    var btn=workflowButton(stage),current=stage===role;
    if(!btn)return;
    btn.classList.toggle('is-current',current);
    if(current){
      btn.setAttribute('aria-current','step');
      btn.disabled=true;
      btn.removeAttribute('aria-disabled');
    }else{
      btn.removeAttribute('aria-current');
      btn.disabled=false;
      btn.removeAttribute('aria-disabled');
    }
  });

  stages.forEach(function(stage){
    var btn=workflowButton(stage);
    if(!btn||btn.__tiHandoffBound)return;
    btn.__tiHandoffBound=true;
    on(btn,'click',function(e){
      e.preventDefault();
      var current=pageRole(),ok=false;
      if(stage===current)return;
      setButtonBusy(
        btn,
        stage==='designer'?'Opening Designer…':
        stage==='materials'?'Opening Materials…':
        stage==='construction'?'Opening Construction…':
        'Opening Cutting Lists…'
      );
      if(stage==='designer')ok=goToDesigner();
      else if(stage==='materials')ok=goToMaterials();
      else if(stage==='construction')ok=goToConstruction();
      else ok=goToManufacturing();
      if(!ok)restoreButton(btn)
    })
  });

  windowIssueNotice();
  if(role==='materials'||role==='construction'||role==='manufacturing'){
    var state=readNav();
    if(state&&state.target===role)clearNav()
  }
  return true
}
function ensureNavigationUI(){return renderWorkflowNav()}
function removeNavigationUI(){removeLegacyNavigationUI();var nav=D.getElementById('ti-workflow-nav');if(nav)nav.querySelectorAll('[data-ti-stage]').forEach(function(btn){btn.__tiHandoffBound=false})}
function focusWindowAfterReturn(focus,tries){
  if(!focus||!focus.id||!focus.wall)return;
  var e=W.ThermoAspenWallOpeningEditorV1;
  if(e&&typeof e.focusProjectWindowIssue==='function'&&e.focusProjectWindowIssue(focus.id,focus.wall,true))return;
  if(tries>0)W.setTimeout(function(){focusWindowAfterReturn(focus,tries-1)},150);
  else dispatch('ThermoAspenWindowIssueFocusFailed',{id:focus.id,wall:focus.wall});
}
function autoApplyReturnedProject(tries){
  var nav=readNav();if(!nav||nav.target!=='designer')return;
  if(!hasWorkingProject()){clearNav();return}if(autoApplying)return;
  if(designer()&&store()&&typeof store().importProject==='function'){
    autoApplying=true;
    applyToDesigner().then(function(result){
      var focus=nav.windowIssue||null;
      clearNav();autoApplying=false;
      dispatch('ThermoAspenProjectHandoffReturnApplied',{version:VERSION,revision:getRevision(),result:clone(result)});
      if(focus)focusWindowAfterReturn(focus,100);
    }).catch(function(error){
      autoApplying=false;
      dispatch('ThermoAspenProjectHandoffReturnError',{version:VERSION,error:String(error&&error.message||error||'Unknown error')});
    });return
  }
  tries=tries==null?50:tries;
  if(tries>0)W.setTimeout(function(){autoApplyReturnedProject(tries-1)},100)
}
function idleCapture(){var run=function(){if(pageRole()==='designer'&&!(readNav()&&readNav().target==='designer'))captureCurrent()};if(typeof W.requestIdleCallback==='function')W.requestIdleCallback(run,{timeout:2000});else W.setTimeout(run,600)}
function initNavigation(){removeLegacyConstructionGuards();ownNav();ensureNavigationUI();if(pageRole()==='designer'&&!(readNav()&&readNav().target==='designer'))idleCapture();autoApplyReturnedProject();var tries=40;(function wait(){if(ensureNavigationUI())return;if(--tries>0)setTimeout(wait,100)})()}
function destroy(){
  removeLegacyConstructionGuards();
  while(off.length)try{off.pop()()}catch(e){}
  removeNavigationUI();
  var notice=D.getElementById('ti-window-issues-notice');if(notice)notice.remove();
  if(W.ThermoAspenProjectHandoff===api)W.ThermoAspenProjectHandoff=null
}
var api={version:VERSION,storage:'sessionStorage',storageKey:KEY,navigationStorageKey:NAV_KEY,projectSchemaVersion:SCHEMA_VERSION,materialsUrl:MATERIALS_URL,designerUrl:DESIGNER_URL,constructionUrl:CONSTRUCTION_URL,manufacturingUrl:MANUFACTURING_URL,hasWorkingProject:hasWorkingProject,getRecord:readRecord,getDesign:getDesign,getRevision:getRevision,getPageRole:pageRole,getNavigationState:readNav,captureCurrent:captureCurrent,patchInteriorFinish:patchInteriorFinish,patchConstructionSpec:patchConstructionSpec,syncProcurement:syncProcurement,syncOptimiser:syncOptimiser,applyToDesigner:applyToDesigner,goToMaterials:goToMaterials,goToDesigner:goToDesigner,goToConstruction:goToConstruction,goToManufacturing:goToManufacturing,goToWindowIssue:goToWindowIssue,getWindowIssueStatus:getWindowIssueStatus,clearNavigation:clearNav,clear:clear,destroy:destroy};
if(W.ThermoAspenProjectHandoff&&typeof W.ThermoAspenProjectHandoff.destroy==='function')try{W.ThermoAspenProjectHandoff.destroy()}catch(e){}
W.ThermoAspenProjectHandoff=api;
on(W,'ThermoAspenSaunaDesignerUpdated',function(e){
  if(pageRole()!=='designer'||(readNav()&&readNav().target==='designer'))return;
  var p=e&&e.detail&&e.detail.project,rec;
  if(p&&p.room){
    rec=readRecord()||minimalRecord(p);
    rec.design=clone(p);
    applyProcurement(rec,preferences());
    applyOptimiser(rec,optimiserState());
    rec.generated=null;
    writeRecord(rec,'designer-update');
  }else captureCurrent()
});
on(W,'ThermoAspenWindowIssuesUpdated',function(){
  if(pageRole()!=='designer'||(readNav()&&readNav().target==='designer'))return;
  var record=captureCurrent();
  if(record)dispatch('ThermoAspenHandoffWindowAuditUpdated',{state:getWindowIssueStatus()});
});
on(W,'ThermoAspenProjectHandoffUpdated',function(){if(pageRole()==='construction'||pageRole()==='manufacturing')windowIssueNotice()});
on(W,'ThermoAspenSaunaMaterialsPreferencesUpdated',function(e){if(hasWorkingProject())syncProcurement(e&&e.detail)});
on(W,'ThermoAspenCladdingRecommendationUpdated',function(){if(hasWorkingProject())syncOptimiser()});
removeLegacyConstructionGuards();
if(D.readyState==='loading')on(D,'DOMContentLoaded',initNavigation);else setTimeout(initNavigation,0);
dispatch('ThermoAspenProjectHandoffReady',{version:VERSION,projectSchemaVersion:SCHEMA_VERSION,hasWorkingProject:hasWorkingProject(),storage:'sessionStorage',navigation:true});
})(window,document);
